import React from 'react';
import InfoTile from '../InfoTile';

function PressReleaseTabComponent({ data }) {
  return (
    <div className='lyt-press'>
        <ul className='lyt-press__list-wrap'>
            {data?.map((item, index) => {
                return (
                  <li className='lyt-press__list-item' key={index}>
                    <InfoTile
                      title={item.heading}
                      mediaUrl={item?.mediaUrl}
                      time={item.publishDate}
                      description={item.description}
                      articleUrl={item.articleUrl}
                      variant={item.type}
                      croppedMediaUrl={item?.thumbnailUrl}
                    />
                </li>
                )
            })}
        </ul>
    </div>
  )
}

export default PressReleaseTabComponent